var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00254 0C5.96308 0 4.30977 1.65331 4.30977 3.69277V6.15582H3.07605C2.16962 6.15582 1.43481 6.89062 1.43481 7.79705V14.3588C1.43481 15.2652 2.16962 16 3.07605 16H12.9234C13.8299 16 14.5647 15.2652 14.5647 14.3588V7.79705C14.5647 6.89062 13.8299 6.15582 12.9234 6.15582H11.6953V3.69277C11.6953 1.65331 10.042 0 8.00254 0ZM10.8747 6.15582V3.69277C10.8747 2.10652 9.58879 0.820616 8.00254 0.820616C6.4163 0.820616 5.13039 2.10652 5.13039 3.69277V6.15582H10.8747Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.542cfd4265c18292232d1cb1cc4472e2.svg";
export { ForwardRef as ReactComponent };